import { useGetters } from 'vuex-composition-helpers'
import { computed, Ref } from 'vue'
import { CostCenter, type MultiselectOption } from '@ironsight/types'
import sortedUniqBy from 'lodash/sortedUniqBy'

export function useCostCenterFilter(): {
  options: Ref<MultiselectOption[]>
} {
  const { getSortedCostCenterArray } = useGetters('costCenters', ['getSortedCostCenterArray'])

  const options = computed<MultiselectOption[]>(() => {
    const costCenters = sortedUniqBy(getSortedCostCenterArray.value as CostCenter[], 'label')

    return costCenters.map((cc) => ({
      label: cc.label,
      value: cc.label,
      description: cc.description,
    }))
  })

  return { options }
}
